import { useToggle } from "react-use"

import { NewBookingPageLink } from "app/AppRouter/links"
import { CurrencySelectorPayment } from "modules/BookingCommon/components"
import { Button, Img } from "ui-kit/components-branded/index"
import { paymentStateType } from "modules/Booking/PaymentPage/constants"
import { createdBookingLoader } from "modules/BookingCommon/common/queries"
import { useCurrency } from "modules/Booking/common/hooks"
import { isBookingAvailable } from "utils/bookingAvailable"

export function TryAgainPage({
    changePaymentPageState,
}: {
    changePaymentPageState: (state: paymentStateType) => void
}) {
    const bookingHash = createdBookingLoader.getHash()
    const { data: bookingDetails } = createdBookingLoader.useGet(bookingHash)
    const bookingAvailable = bookingDetails ? isBookingAvailable(bookingDetails.psy) : false
    const [loading, toggleLoading] = useToggle(false)
    const { currency, setCurrency, updateCurrency } = useCurrency()

    const handleClick = async () => {
        toggleLoading()
        await updateCurrency()
        changePaymentPageState(paymentStateType.renderWidget)
    }

    return (
        <div className="redesign-container">
            <div className="try-again__container">
                <section className="try-again">
                    <div>
                        <div className="try-again__headline">Запись и оплата</div>
                        <div className="try-again__text">
                            Завершите оплату или выберите другое время, если передумали.
                        </div>
                    </div>
                    <Img
                        className="try-again__card-illustration mgb-2"
                        src="booking_try_again_illustration.svg"
                        alt="Иллюстрация с предложением попробовать снова"
                        width={296}
                        height={168}
                    />
                    <CurrencySelectorPayment currency={currency} updateCurrency={setCurrency} />
                    <Button
                        onClick={() => void handleClick()}
                        color="primary"
                        isLoading={loading}
                        disabled={loading}
                    >
                        Перейти к оплате
                    </Button>
                    {bookingDetails && bookingAvailable && (
                        <NewBookingPageLink
                            target="_blank"
                            className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 try-again__secondary-button transition-ease"
                            hashId={bookingDetails.psy.hash_id}
                        >
                            Выбрать другое время
                        </NewBookingPageLink>
                    )}
                </section>
            </div>
        </div>
    )
}
